export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.revision   = json.revision
      this.group      = json.group
      this.status     = json.status
      this.pcc        = json.pcc
      this.columns    = json.columns

      this.sundries   = json.sundries
      this.keys       = json.keys
      this.filters    = json.filters
      
      
      this.gmx_tableCoordinates('x', this.columns, 0)
      // this.status.width = this.columns[this.columns.length-1].ex


    },



    set_Gradients() {

    },
  },
}